import React from 'react';
import { Link } from 'react-router-dom';
import { Building2 } from 'lucide-react';
import LanguageSwitcher from './LanguageSwitcher';

const Header = () => {
  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center space-x-3 hover:opacity-80 transition-opacity">
            <Building2 className="w-8 h-8 text-[#C9A961]" />
            <div>
              <h1 className="text-lg font-extrabold text-[#0A2540] tracking-tight">Seeschloss-Hotel</h1>
              <p className="text-xs text-[#C9A961] font-semibold">Kellersee</p>
            </div>
          </Link>
          <nav className="hidden md:flex items-center space-x-6">
            <Link to="/" className="text-sm font-semibold text-slate-700 hover:text-[#C9A961] transition-colors">
              Hotel & Villa
            </Link>
            <Link to="/restaurant" className="text-sm font-semibold text-slate-700 hover:text-[#C9A961] transition-colors">
              Restaurant
            </Link>
            <LanguageSwitcher />
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
